<template lang="pug">
    div#services-view
        mainHeader
        div.box
            div.has-text-centered
                strong.title Services
            hr
            div.content
                strong.subtitle  Τομείς δραστηριότητας:
                div.columns.is-centered
                    div.column.is-narrow.has-text-left
                        ul
                            li Automation
                            li Electronics
                            li Security
                    div.column.is-2
                    div.column.is-narrow.has-text-left
                        ul
                            li Aerospace (UAVS)
                            li Marine electronics 
                            li Audio applications

            hr

            div.columns.is-multiline

                div.column.is-half
                    div.card.has-equal-height
                        //- div.card-header
                            p.card-header-title PCB Design
                        div
                            p.is-size-5.has-text-weight-bold.topic-card-title PCB Design
                        div.card-image
                            figure.image
                                img(:src="`${baseUrl}img/PCB_DESIGN_1.jpg`")
                        div.card-content
                            div.content Στη MindCore αναλαμβάνουμε υπεύθυνα το σχεδιασμό PCB (τυπωμένου κυκλώματος-πλακέτα), με βάση τις προδιαγραφές που λαμβάνουμε από τον ενδιαφερόμενο. Έχοντας την εμπειρία και την τεχνογνωσία στο σχεδιασμό και τηρώντας απόλυτα τις προδιαγραφές, σχεδιάζουμε υψηλής ποιότητας κυκλώματα, κρατώντας παράλληλα το κόστος της επερχόμενης παραγωγής σε χαμηλά επίπεδα.

                div.column.is-half
                    div.card.has-equal-height
                        //- div.card-header
                            p.card-header-title Software Design
                        div
                            p.is-size-5.has-text-weight-bold.topic-card-title Software Design
                        div.card-image
                            figure.image
                                img(:src="`${baseUrl}img/software_dev.jpg`")
                        div.card-content
                            div.content Στη MindCore αναλαμβάνουμε την σύνταξη/παραγωγή κώδικα που προορίζεται για ενσωματωμένα συστήματα και μικροεπεξεργαστές, καθώς και τη δημιουργία software για εφαρμογή σε υπολογιστές, πχ. εφαρμογές μηχανογράφησης, απομακρυσμένου ελέγχου και διαχείρισης δεδομένων και συσκευών (IoT, cloud).
            
                div.column.is-half
                    div.card.has-equal-height
                        //- div.card-header
                            p.card-header-title Mechanical Design
                        div
                            p.is-size-5.has-text-weight-bold.topic-card-title Mechanical Design
                        
                        div.card-image
                            figure.image.is-4by3
                                img(:src="`${baseUrl}img/Mech_3D_design.jpg`")
                        div.card-content
                            div.content Στη MindCore αναλαμβάνουμε κάθε μηχανολογικό σχεδιασμό (σε 3D CAD πρόγραμμα), που απαιτείται για την παραγωγή ενός πρωτότυπου ή ενός τελικού προϊόντος, όπως το εξωτερικό περίβλημα-κέλυφος, τα διάφορα μηχανικά κινούμενα μέρη, 3D printed εξαρτήματα και οτιδήποτε άπτεται στο κατασκευαστικό κομμάτι της μηχανολογίας.
                
                div.column.is-half
                    div.card.has-equal-height
                        div
                            p.is-size-5.has-text-weight-bold.topic-card-title Prototype & Production
                        
                        div.card-image
                            figure.image.is-4by3
                                img(:src="`${baseUrl}img/SAM_0742.jpg`")
                                
                        div.card-content
                            div.content Συνδυάζοντας τους τομείς εξειδίκευσης μας (PCB-software-mechanical design), όπως και ένα δίκτυο υπεύθυνων εξωτερικών συνεργατών, παρέχουμε ολοκληρωμένες λύσεις σε ό,τι αφορά τη μελέτη, το σχεδιασμό και την παραγωγή πρωτότυπου ή τελικού προϊόντος. 
                            div.content Σχετικά με το πρωτότυπο, υπάρχει επίσης και η δυνατότητα για fast prototyping (“γρήγορο” πρωτότυπο), χρησιμοποιώντας έτοιμα αναπτυξιακά συστήματα του εμπορίου, όπως Arduino, Raspberry Pi, ST-Discovery κ.α., μειώνοντας το κόστος και το χρόνο ανάπτυξης και δίνοντας παράλληλα μια καλή και λειτουργική εικόνα του προϊόντος στον ενδιαφερόμενο.
        
        Footer
                                      
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import Footer from '@/components/Footer.vue';

export default {
    name: 'services',
    components: {
        MainHeader,
        Footer,
    },
    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
        };
    }  
}
</script>

<style scoped>
.topic-card-title {
    padding: 0.5rem;
}

ul:nth-of-type(1) {
    list-style-position: outside;
    list-style-type: disc;
}

.box {
    background-color: #E8E8E8;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;
}

.card {
    /* background-color: #E8E8E8; */
    background-color: #F0F0F0;
}

.has-equal-height {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.has-equal-height .card-footer {
  margin-top: auto;
}

</style>


